module.exports = __webpack_public_path__ + "static/media/preview.68dc875a.png";